
import React, { createContext, useState, useContext } from "react";

const EnergiaRefrigeracaoCamaraContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id] = useState();

  return (
    <EnergiaRefrigeracaoCamaraContext.Provider value={{ energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id }} >
      {children}
    </EnergiaRefrigeracaoCamaraContext.Provider>
  );
}

export function useEnergiaRefrigeracaoCamaraContext() {
  const context = useContext(EnergiaRefrigeracaoCamaraContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id } = context;
  return { energiaRefrigeracaoCamara_id, setEnergiaRefrigeracaoCamara_id };
}

